import { Location } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { RelevantLabDocument } from "src/app/models/relevant-lab-document.model";
import { RelevantLab } from "src/app/models/relevant-lab.model";
import { RelevantLabService } from "src/app/services/relevant-lab.service";


@Component({
    selector: 'app-relevant-lab-component',
    templateUrl: './relevant-lab.component.html'
})
export class RelevantLabComponent implements OnInit {
    relevantLabID = '';
    relevantLab = new RelevantLab;
    relevantLabsLoaded = false;
    documentsLoaded = false;

    constructor(private activatedRoute: ActivatedRoute,
                private location: Location,
                private relevantLabService: RelevantLabService,
                private router: Router) {
        this.relevantLabID = this.activatedRoute.snapshot.paramMap.get("id");
        this.relevantLabService.getRelevantLabByID(this.relevantLabID);
    }
    
    ngOnInit() {
        this.relevantLabService.currentRelevantLabView.subscribe(relevantLab => {
            if(relevantLab.id != null) {
              this.relevantLab = relevantLab;
              this.relevantLabsLoaded = true;
              if(relevantLab.documents.length > 0) {
                this.documentsLoaded = true;
              }
            } 
          });
    }

    public trackItem (index: number, item: RelevantLabDocument) {
        return item.document_name;
    }

    handleDocumentTap(labIndex) {
      if(this.relevantLab.documents[labIndex].document_type == 'pdf' || this.relevantLab.documents[labIndex].document_type == 'doc' || this.relevantLab.documents[labIndex].document_type == 'docx') {
        // open url in new tab
        window.open(this.relevantLab.documents[labIndex].document_attached, '_blank');
      } else {
        this.router.navigate(['/relevant-lab-document', this.relevantLab.documents[labIndex].document_attached, this.relevantLab.documents[labIndex].document_type]);
      }
    }

    goBack() {
        this.location.back();
      }
    

}